import { boolean, decimal, pgEnum, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { assets } from "./asset"
import { companies } from "./company"
import { contacts } from "./contact"
import { estates } from "./estate"
import { insurances } from "./insurance"
import { trusts } from "./trust"

export const beneficiaryClassEnum = pgEnum("beneficiary_class_enum", [
  "PRIMARY",
  "CONTINGENT",
  "TERTIARY",
])

export const distributionMethodEnum = pgEnum("distribution_method_enum", [
  "PER_STIRPES",
  "PER_CAPITA",
  "SPECIFIC_AMOUNT",
  "SPECIFIC_ASSET",
  "DISCRETIONARY",
])

export const beneficiaries = pgTable("beneficiary", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),

  assetId: uuid("asset_id").references(() => assets.id, { onDelete: "cascade" }),
  trustId: uuid("trust_id").references(() => trusts.id, { onDelete: "cascade" }),
  insuranceId: uuid("insurance_id").references(() => insurances.id, { onDelete: "cascade" }),
  estateResidual: boolean("estate_residual").default(false),

  contactId: uuid("contact_id").references(() => contacts.id, { onDelete: "cascade" }),
  companyId: uuid("company_id").references(() => companies.id, { onDelete: "cascade" }),
  targetTrustId: uuid("target_trust_id").references(() => trusts.id, { onDelete: "cascade" }),
  targetEstateId: uuid("target_estate_id").references(() => estates.id, { onDelete: "cascade" }),

  percentageShare: decimal("percentage_share", { precision: 5, scale: 2 }),
  beneficiaryClass: beneficiaryClassEnum("beneficiary_class_enum").notNull().default("PRIMARY"),
  distributionMethod: distributionMethodEnum("distribution_method_enum"),

  conditions: text("conditions"),
  isDraft: boolean("is_draft").default(false).notNull(),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
